import { Region } from 'stores/type';

export enum ECardType {
    CreditCard = 'Credit Card',
    DirectDebit = 'Direct Debit',
    OnAccount = 'On Account',
}

export enum EPaymentSchedule {
    Monthly = 'Monthly',
    Annual = 'Annual',
}

export enum ECardStatus {
    Active = 'Active',
    Inactive = 'Inactive',
}

export enum ECreditCardType {
    Visa = 'Visa',
    MasterCard = 'MasterCard',
    AmericanExpress = 'American Express',
}

export enum EPaymentProfileActionType {
    FETCH_SUCCEEDED = 'PAYMENT_PROFILE_FETCH_SUCCEEDED',
    FETCH_FAILED = 'PAYMENT_PROFILE_FETCH_FAILED',
    FETCH_REQUESTED = 'PAYMENT_PROFILE_FETCH_REQUESTED',
    POST_REQUESTED = 'PAYMENT_PROFILE_POST_REQUESTED',
    POST_SUCCEEDED = 'PAYMENT_PROFILE_POST_SUCCEEDED',
    POST_FAILED = 'PAYMENT_PROFILE_POST_FAILED',
}

interface IBasePaymentProfileItem {
    payment_schedule: EPaymentSchedule;
    payment_method: ECardType;
    status: ECardStatus;
    primary_profile: boolean;
}

export interface ICreditCardPaymentProfileItem extends IBasePaymentProfileItem {
    payment_method: ECardType.CreditCard;
    credit_card: {
        name_on_card: string;
        card_token: string;
        last_four_digits: string;
        type: ECreditCardType;
        expiry_month: string;
        expiry_year: string;
    };
}

export interface IDirectDebitPaymentProfileItem extends IBasePaymentProfileItem {
    payment_method: ECardType.DirectDebit;
    direct_debit: {
        bank_name: string;
        bsb: string;
        account_number: string;
    };
}

export type IPaymentProfileItem =
    | IBasePaymentProfileItem
    | ICreditCardPaymentProfileItem
    | IDirectDebitPaymentProfileItem;

export interface IPaymentProfile {
    is_partner_pay: boolean;
    region?: Region;
    item: IPaymentProfileItem;
}

export interface IPostPaymentProfileAction {
    type: EPaymentProfileActionType.POST_REQUESTED;
    meta: { failureMessage: string; successMessage: string };
    payload: {
        params: {};
        data: BackendPostPaymentProfile;
    };
}

export interface IFetchPaymentProfileAction {
    type: EPaymentProfileActionType.FETCH_REQUESTED;
    payload: {
        params: {};
    };
}

export interface IPaymentProfileAction {
    type: EPaymentProfileActionType;
    data: IPaymentProfile[];
    error: Error;
}

export interface BackendPostCreditCard {
    card_token: string;
    name_on_card: string;
    expiry_month: string;
    expiry_year: string;
    type: string;
    last_four_digits: string;
}

export interface BackendPostDirectDebit {
    bank_name: string;
    bsb: string;
    account_number: string;
}

export type BackendPostPaymentProfile = BackendPostCreditCard | BackendPostDirectDebit;
